import {apiGatewayRequest} from 'services/request/handler'

export function getOberon(route: string) {
    return apiGatewayRequest()
        .get(route)
        .then((res: Response) => res.json())
}

export function getOberonIgnoreErrors(route: string) {
    return apiGatewayRequest()
        .get(route, {throwHttpErrors: false})
        .then((res: Response) => res.json())
}

export function deleteOberon(route: string) {
    return apiGatewayRequest().delete(route)
}

export function postOberon(route: string, body?: Record<string, any>) {
    return apiGatewayRequest().post(route, {
        json: body
    })
}

export function patchOberon(route: string, body?: Record<string, any>) {
    return apiGatewayRequest().patch(route, {
        json: body
    })
}

export function putOberon(route: string, body?: Record<string, any>) {
    return apiGatewayRequest().put(route, {
        json: body
    })
}
